// Dizajnové tokeny pre Prehľad (dashboard).
//
// Zámerne oddelené od DashboardPanel.js — ten používajú aj Asistent a karta
// zamestnanca a jeho vzhľad sa tu meniť nesmie.
//
// Myšlienka: prehľad je výpis z účtu, len menou sú ľudia a čas. Jediná výrazná
// plocha je tmavá „karta prítomnosti“ (hero); všetko ostatné je pokojné —
// biela plocha, vlasová linka, žiadny tieň, žiadne farebné ikonkové dlaždice.

export const DASH = {
    radius: 18,
    radiusSm: 12,
    radiusXs: 10,
    pad: { xs: 2.25, sm: 3 },
    gap: 2.5,
    chartHeight: 260,
    feedMaxHeight: 400,
    heroMinHeight: 560,
    // Displejové písmo — len na veľké čísla a nadpisy sekcií, nikdy na text.
    display: '"Schibsted Grotesk", "Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    numeric: { fontVariantNumeric: 'tabular-nums' },
};

// Tmavá plocha hero karty. V light režime kontrastuje s plátnom, v dark je
// tmavšia než papier, takže stále číta ako samostatná vrstva.
export const inkSurface = (isDark) => ({
    bg: isDark ? '#070E1A' : '#0B1524',
    border: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.06)',
    text: '#FFFFFF',
    textMuted: 'rgba(255,255,255,0.62)',
    textFaint: 'rgba(255,255,255,0.38)',
    hairline: 'rgba(255,255,255,0.10)',
    track: 'rgba(255,255,255,0.10)',
});

// Sémantika udalostí na nástenke: tri farby, tri triedy udalostí. Návrat
// z prestávky je stále prestávka, líši sa len ikonou — štvrtá farba by pridala
// položku do legendy bez toho, aby niečo vysvetlila.
// Farby sú z loga Effzone (theme.js), aby nástenka nezaviedla vlastnú paletu.
export const EVENT_TONES = {
    arrival: '#3BA557',
    break_start: '#FC9D0C',
    break_end: '#FC9D0C',
    departure: '#7C8DA6',
    // Koniec smeny, ktorý zapísala automatizácia. Farbu má ako odchod (lebo ním
    // je), odlišuje ho ikona a názov — inak by si vypýtal štvrtú farbu do legendy.
    auto_end: '#7C8DA6',
};

// Stavy úloh používajú tie isté tri farby ako udalosti dochádzky: hotovo je
// zelené, rozrobené oranžové, zvyšok pokojne sivý. Po termíne je jediná výnimka
// — červená, lebo je to jediný stav, ktorý si pýta zásah.
export const TASK_TONES = {
    completed: '#3BA557',
    in_progress: '#FC9D0C',
    pending: '#7C8DA6',
    cancelled: '#7C8DA6',
    overdue: '#D64545',
};

export const PRESENCE_TONES = {
    working: '#3BA557',
    onBreak: '#FC9D0C',
    away: 'rgba(255,255,255,0.16)',
};

// Fotky profilov sú uložené ako cesty s lomkou a servuje ich app doména
// (rovnaké pravidlo ako v mobilnej appke).
const PHOTO_BASE_URL = 'https://app.effzone.com';

export const resolvePhotoUrl = (url) => {
    if (!url || !url.trim()) return null;
    return url.startsWith('http') ? url : `${PHOTO_BASE_URL}${url}`;
};

// Iniciály: prvé písmeno každého slova, prvé dve — rovnako ako v mobile.
export const getInitials = (name) => (name || '')
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

// Deterministická farba avatara z mena — aby sa tváre bez fotky dali odlíšiť.
const AVATAR_TINTS = ['#2563EB', '#7C3AED', '#0E9F6E', '#D97706', '#DB2777', '#0891B2'];

export const avatarTint = (seed) => {
    const str = String(seed || '');
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
        hash = (hash * 31 + str.charCodeAt(i)) % 100000;
    }
    return AVATAR_TINTS[hash % AVATAR_TINTS.length];
};
